import { routes } from 'types/routes.ts'

export const ALL_ADDRESSES_ONLY_ROUTES: routes[] = [routes.USER_PAYMENT, routes.BILLING_INVOICES, routes.USER_PAYMENT]
export const CAN_SHOW_ALL_ADDRESSES_ROUTES: routes[] = []
